"use client"

import styled from "@emotion/styled"
import { Box } from "@mui/material"
import Image from "next/image"
import { extractProperty, getUmbracoMediaUrl } from "utils"
import WhiteBgHeading from "../../Projects/Marketing/ApartmentMarketingForRent/WhiteBgHeading"

const StyledSection = styled.section`
  padding-block: 60px;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 32px;
  ${(props) => props.theme.breakpoints.up("md")} {
    gap: 40px;
  }
`

const StyledItemList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  ${(props) => props.theme.breakpoints.up("md")} {
    align-items: normal;
    flex-direction: row;
    justify-content: center;
  }
`

const StyledItem = styled.li`
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  border-radius: 8px;
  border: 1px solid #e4e4e4;
  background: white;
  overflow: hidden;
  padding: 16px;
  gap: 16px;
  max-width: 335px;
`

const StyledItemTitle = styled.h3`
  margin: 0;
  padding: 0;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
`

const StyledItemSubTitle = styled.p`
  margin: 0;
  padding: 0;
  font-size: 18px;
  font-weight: 300;
  line-height: 150%;
  letter-spacing: -0.36px;
`

const CustomWhiteBgHeading = styled(WhiteBgHeading)`
  .modal-title {
    strong {
      margin-left: 8px;
    }
  }
`

type Props = {
  data: any
}

const CareerJoinUs = ({ data }: Props) => {
  const mainTitleDark = extractProperty(data, "mainTitleDark")
  const mainTitleLight = extractProperty(data, "mainTitleLight")
  const subTitle = extractProperty(data, "subTitle")
  const itemsList = (extractProperty(data, "itemsList") || [])
    ?.map((item: any) => ({
      icon: extractProperty(item, "icon"),
      title: extractProperty(item, "title"),
      subTitle: extractProperty(item, "subTitle"),
    }))
    .filter((i: any) => Boolean(i))

  return (
    <StyledSection>
      <CustomWhiteBgHeading
        isCentered
        subTitle={subTitle}
        title={`${mainTitleDark}<strong>${mainTitleLight}</strong>`}
        titleCls="modal-title"
        subTitlePaddingMobile="16px 20px"
        subTitleFontWeight={300}
      />
      {itemsList && itemsList.length > 0 && (
        <StyledItemList>
          {itemsList?.map(({ icon, title, subTitle }: any, index: number) => (
            <StyledItem key={index}>
              {icon && (
                <Image
                  src={getUmbracoMediaUrl(icon)}
                  alt={title || `icon-${index}`}
                  width={62}
                  height={62}
                />
              )}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                {title && <StyledItemTitle>{title}</StyledItemTitle>}
                {subTitle && <StyledItemSubTitle>{subTitle}</StyledItemSubTitle>}
              </Box>
            </StyledItem>
          ))}
        </StyledItemList>
      )}
    </StyledSection>
  )
}
export default CareerJoinUs
